import IconAudio from './component.jsx'
export default IconAudio
